export const roles = {
  STUNNR_BE_CLIENT_ACCESS: 46
}